function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  opacity: ", ";\n  z-index: ", ";\n  cursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box } from 'pcln-design-system';
var StyledOverlay = styled(Box)(_templateObject(), function (_ref) {
  var popoverOpen = _ref.popoverOpen,
      overlayOpacity = _ref.overlayOpacity;
  return popoverOpen ? overlayOpacity : 0;
}, function (_ref2) {
  var zIndex = _ref2.zIndex;
  return zIndex < 0 ? 0 : zIndex;
});

var Overlay = function Overlay(_ref3) {
  var className = _ref3.className,
      popoverOpen = _ref3.popoverOpen,
      handleClick = _ref3.handleClick,
      overlayOpacity = _ref3.overlayOpacity,
      zIndex = _ref3.zIndex;
  return /*#__PURE__*/React.createElement(StyledOverlay, {
    className: className,
    "aria-hidden": "true",
    tabIndex: "-1",
    onClick: handleClick,
    popoverOpen: popoverOpen,
    overlayOpacity: overlayOpacity,
    zIndex: zIndex,
    bg: 'background.darkest'
  });
};

Overlay.propTypes = {
  className: PropTypes.string,
  popoverOpen: PropTypes.bool,
  handleClick: PropTypes.func,
  overlayOpacity: PropTypes.number,
  zIndex: PropTypes.number
};
Overlay.defaultProps = {
  popoverOpen: true,
  overlayOpacity: 0,
  zIndex: 101
};
export default Overlay;